import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramDocsFilesPage } from './program-docs-files';
import { MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule, MatExpansionModule } from '@angular/material';
import { FileUploadModule } from 'ng2-file-upload';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    ProgramDocsFilesPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramDocsFilesPage),
    ComponentsModule,
    FileUploadModule,
    MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule, MatExpansionModule
  ],
})
export class ProgramDocsFilesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-docs-files/program-docs-files.module.ts